"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const extension_1 = require("../extension");
const profiler_1 = require("../profiler/node-visitor/profiler");
class TwingExtensionProfiler extends extension_1.TwingExtension {
    constructor(profile) {
        super();
        this.actives = [];
        this.actives.push(profile);
    }
    enter(profile) {
        this.actives[0].addProfile(profile);
        this.actives.unshift(profile);
    }
    leave(profile) {
        profile.leave();
        this.actives.shift();
        if (this.actives.length === 1) {
            this.actives[0].leave();
        }
    }
    getNodeVisitors() {
        return [new profiler_1.TwingProfilerNodeVisitorProfiler('TwingExtensionProfiler')];
    }
}
exports.TwingExtensionProfiler = TwingExtensionProfiler;
TwingExtensionProfiler.context = new Map();
